import { put, call, select, takeLatest } from "redux-saga/effects";
import moment from "moment-timezone";
import { userAuthenticate, userRefresh, isLoggedIn, userLogout, isLoggedInPost2 } from "../api/ssoApi";
import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";
import { proxyInfo } from '../api/epicApi';
import * as portalAPI from "../api/portalApi";
import * as providerAPI from "../api/providerApi";
import * as account from "../api/accountApi";
import * as Tools from "../helpers/Tools";
import Cookies from "cookies-js";
import { logAPI } from "../api/andyliticsApi";
import { getDomain } from "../helpers/Tools";
import { authContext } from "../adalConfig";
import { ConvertToken } from "../api/localApi";
import * as instaDocBFFAPI from "../api/instaDocBFFApi";
import * as limbo from "../api/limboApi";

export function* watchUserAuthenticate() {
    yield takeLatest([types.USER_AUTHENTICATE], authorize);
    yield takeLatest([types.USER_AUTHENTICATE_REFRESH], refresh);
    yield takeLatest([types.VERIFY_LOGIN], verifyLogin);
    yield takeLatest([types.LOGOUT], logoutRedirect);
    yield takeLatest([types.LOGIN_FORM_SUCCESS], loginSuccess);
    yield takeLatest([types.REFRESH_TOKEN], refreshToken);
    yield takeLatest([types.LOAD_TERMS_AND_CONDITIONS], loadTermsAndConditions);
    yield takeLatest([types.ACCEPT_TERMS_AND_CONDITIONS], acceptTermsAndConditions);
    //yield takeLatest([types.SET_AD_USER_DATA], ADAuthenticated);
    yield takeLatest([types.SET_AD_ID_TOKEN], ADAuthenticated);
    yield takeLatest([types.POST_LOGIN_START], PostLoginAsyncDataLoad);
    yield takeLatest([types.APP_START], PostLoginAsyncDataLoad);
    yield takeLatest([types.INSTADOC_TOKEN_REFRESH], FetchInstadocToken);
    yield takeLatest([types.APPOINTMENTS_REFRESH_DATA], AppointmentsRefresh);
    yield takeLatest([types.SYNC_ROOMS], SyncAppointments);
    yield takeLatest([types.INSTADOC_PROVIDERS_START], handleProviders);
    yield takeLatest([types.SET_PROVIDER_EPIC_IDS], handleProviderEpicIds);
    yield takeLatest([types.ADAL_TOKEN_REFRESH], adalTokenRefresh);
    yield takeLatest([types.USER_SETTINGS], handleUserSettings);
}
export function* adalTokenRefresh(data) {

    var domain = yield select((state) => state.domain);

    //debugger;
    if (domain.adt) {
        var oNewToken = yield Tools.safeCall(ConvertToken, domain.adt, domain.un);
        yield put({ type: types.SET_HEALTH_SOURCE_TOKEN, result: oNewToken.result });
    }
}

const enableSyncCall = window && window.serverData && window.serverData.data && window.serverData.data.enableSyncCall;
const manageProviderMobileNoInSettings = window && window.serverData && window.serverData.data && window.serverData.data.manageProviderMobileNoInSettings;

export function* handleProviderEpicIds(data) {
    const domain = yield select((state) => state.domain);
    if (domain.idt) {
        try {
            if (data.providerEpicIds && data.providerEpicIds.length > 0) {
                yield LoadProviderAppointments(domain.idt, data.providerEpicIds, null, data.providerEpicIds.length === 1 && data.providerEpicIds[0].providerExternalId === '153284');
            }
            if (domain.sdc) {
                yield LoadProviderAppointments(domain.idt, [{ providerExternalId: '153284' }], null, true);
            }
        }
        finally {
            if (data.callback) {
                data.callback();
            }
        }
    }
}

export function* AppointmentsRefresh(payload) {
    const domain = yield select((state) => state.domain);
    if (domain.idt) {
        const data = payload && payload.data;
        const isSameDayCare = data ? data.epicAppointmentDetails.visitType.internalId.trim() === '60148' : domain.sdc;
        if (isSameDayCare) { // fix to bug# 138191 - this is a special case where same day care is in the list of other (non same day care) departments
            const videoVisit = yield select(state => state.videoVisit);
            if (videoVisit && videoVisit.providerInfo && videoVisit.providerInfo.find(p => p.isSameDayCare)) {
                yield LoadProviderAppointments(domain.idt, domain.eids, data, false);
            }
        }
        yield LoadProviderAppointments(domain.idt, isSameDayCare ? [{ providerExternalId: '153284' }] : domain.eids, data, isSameDayCare);
    }
}

export function* SyncAppointments(data) {
    // parameters are data.syncSameDayCare  which is true if you want to sync the same day care calendar
    try {
        const domain = yield select((state) => state.domain);
        var dTodaysDate = new Date();
        var sTodaysDate = formatZeroes((dTodaysDate.getMonth() + 1).toString()) + '/' + formatZeroes(dTodaysDate.getDate().toString()) + '/' + dTodaysDate.getFullYear().toString();

        var dYesterdaysDate = new Date();
        var dEndDate = new Date();
        dYesterdaysDate.setDate(dTodaysDate.getDate() - 1);
        dEndDate.setDate(dTodaysDate.getDate() + 2);

        var sYesterdaysDate = formatZeroes((dYesterdaysDate.getMonth() + 1).toString()) + '/' +
            formatZeroes(dYesterdaysDate.getDate().toString()) + '/' +
            dYesterdaysDate.getFullYear().toString();

        var sEndDate = formatZeroes((dEndDate.getMonth() + 1).toString()) + '/' +
            formatZeroes(dEndDate.getDate().toString()) + '/' +
            dEndDate.getFullYear().toString();

        if (data.syncSameDayCare) {
            yield instaDocBFFAPI.syncRooms(domain.idt, window.serverData.data.sameDayCareProviderId, sYesterdaysDate, sEndDate);
        }
        else if (domain.idt && domain.eid) {
            yield instaDocBFFAPI.syncRooms(domain.idt, domain.eid, sYesterdaysDate, sEndDate);
        }

        if (data && data.shouldRefresh) {
            yield AppointmentsRefresh();
        }
    } catch (ee) {
        console.error(ee);
    } finally {
        if (data.callback) {
            data.callback();
        }
    }
}

export function* handleProviders(data) {
    const start = new Date();
    const domain = yield select((state) => state.domain);
    try {
        var oInstaDocToken = {};
        if (!domain.idt && domain.adt) {
            oInstaDocToken = yield FetchInstadocToken();
        }

        const token = oInstaDocToken && oInstaDocToken.result ? oInstaDocToken.result.tokenString : domain.idt;
        let startDate = new Date().toLocaleDateString('en-US');
        let endDate = new Date().toLocaleDateString('en-US');
        //startDate.setDate(startDate.getDate() - 1);
        //endDate.setDate(endDate.getDate() + 2);

        yield Tools.safeCall(instaDocBFFAPI.subscribeForSync, token, data.departmentId);
        yield Tools.safeCall(limbo.SubscribeDepartment, token, data.departmentId);

        //const response = yield Tools.safeCall(instaDocBFFAPI.getProviders, token, data.departmentId, startDate, endDate);
        const response = yield Tools.safeCall(instaDocBFFAPI.getProvidersV2, token, data.departmentId);
        const providers = response.result && response.result.providers;
        let totalCount = 0;
        if (providers && providers.length > 0) {
            providers.forEach(provider => {
                const count = provider.numberOfActiveApptsToday;
                provider.displayName = `${provider.name} (${count})`;
                totalCount += count;
            });
        }
        const allProviders = { name: 'All Providers', displayName: `All Providers (${totalCount})` };
        if (!response.err) {
            yield put({ type: types.INSTADOC_PROVIDERS_SUCCESS, list: providers, header: allProviders });
            logAPI("Saga.SSO.ProvidersByDepartment.Success", start, null, providers, data.departmentId);
        }
        else {
            yield put({ type: types.INSTADOC_PROVIDERS_FAILURE, error: response.err });
            logAPI("Saga.SSO.ProvidersByDepartment.Failure", start, null, { departmentId: data.departmentId, error: response.err });
        }
    }
    catch (error) {
        yield put({ type: types.INSTADOC_PROVIDERS_FAILURE, error });
        logAPI("Saga.SSO.ProvidersByDepartment.Failure", start, null, { departmentId: data.departmentId, error });
    }
}

export function* LoadProviderAppointments(instaDocToken, epicIds, data, isSameDayCare) {
    try {
        const dTodaysDate = new Date();
        const sTodaysDate = formatZeroes((dTodaysDate.getMonth() + 1).toString()) + '/' + formatZeroes(dTodaysDate.getDate().toString()) + '/' + dTodaysDate.getFullYear().toString();
        dTodaysDate.setDate(new Date().getDate() + 1);
        const endDate = isSameDayCare
            ? formatZeroes((dTodaysDate.getMonth() + 1).toString()) + '/' + formatZeroes(dTodaysDate.getDate().toString()) + '/' + dTodaysDate.getFullYear().toString() + ' 12:00:00 PM'
            : sTodaysDate;
        if (instaDocToken && epicIds && epicIds.length > 0) {
            try {
                var result = null;
                if (!data) {
                    yield put({ type: types.EPIC_PROVIDER_APPOINTMENTS_GET_START, isSameDayCare });
                    result = yield Tools.safeCall(
                        instaDocBFFAPI.getProviderAppointments,
                        instaDocToken,
                        epicIds,
                        null,
                        window.serverData.data.overrideDate && window.serverData.data.overrideDate !== "" ? window.serverData.data.overrideDate : sTodaysDate,
                        window.serverData.data.overrideEndDate && window.serverData.data.overrideEndDate !== "" ? window.serverData.data.overrideEndDate : `${endDate}`
                    );
                }
                else {
                    const apptDetails = data.epicAppointmentDetails;
                    var apptDay = moment(apptDetails.startDateTime).format("MM/DD/YYYY h:mm:ss A");
                    var appointmentDay = moment(apptDetails.startDateTime)._d.toDateString();
                    var todaysDay = moment(new Date())._d.toDateString();
                    if (isSameDayCare) {
                        var tomorrowsDay = moment().add(1, 'days').format("MM/DD/YYYY");
                        if (appointmentDay < todaysDay || apptDay >= `${tomorrowsDay} 12:00:00 PM`) {
                            return;
                        }
                    }
                    else {
                        if (appointmentDay !== todaysDay) {
                            return;
                        }
                    }
                    var matchingProvider = [];
                    const providers = apptDetails.providers;
                    const epic = yield select(state => state.epic);
                    const appointments = isSameDayCare ? epic.sameDayCareAppointments : epic.providerAppointments;
                    for (let p = 0; p < providers.length; p++) {
                        matchingProvider = epicIds.filter(e => e.providerExternalId === providers[p].externalId);
                        if (matchingProvider.length > 0) {
                            const newRecord = Tools.appointmentRecord(data, 'Scheduled');
                            var appointmentFound = false;
                            result = { result: { rooms: appointments } };
                            const csnId = newRecord.epicApptCSNId;
                            for (let i = 0; i < appointments.length; i++) {
                                if (csnId === appointments[i].epicAppointmentDetails.csnId) {
                                    if (apptDetails.status === 'ROOM_CLOSE') {
                                        result.result.rooms.splice(i, 1);
                                    }
                                    else {
                                        appointments[i] = newRecord;
                                    }
                                    appointmentFound = true;
                                    break;
                                }
                            }
                            if (!appointmentFound && newRecord.status !== 'ROOM_CLOSE') {
                                result.result.rooms.push(newRecord);
                            }
                        }
                        break;
                    }
                    if (matchingProvider.length === 0) {
                        return;
                    }
                }

                // count # of appointments per department
                const videoVisit = yield select((state) => state.videoVisit);
                let totalCount = 0;
                const departmentsDictionary = {}; // tracks count of appointments per department
                if (videoVisit.providerInfo && videoVisit.providerInfo.length) {
                    const allDepartments = videoVisit.providerInfo;
                    const departments = allDepartments.filter((department, index) => index > 0); // filter out the first record - 'All Departments'
                    departments.forEach(department => departmentsDictionary[department.id] = 0);
                    if (!result.err) {
                        result.result.rooms.forEach((appointment, index) => {
                            const apptDepartments = appointment.epicAppointmentDetails.departments;
                            let matchingDepartmentId = null;
                            for (let i = 0; i < apptDepartments.length; i++) {
                                const departmentId = apptDepartments[i].internalId;
                                if (typeof departmentsDictionary[departmentId] !== 'undefined') {
                                    matchingDepartmentId = departmentId;
                                    appointment.departmentId = departmentId;
                                    departmentsDictionary[departmentId]++; // count of appointments is increased by 1
                                    totalCount++;
                                    break;
                                }
                            }
                            if (matchingDepartmentId === null && apptDepartments.length/* && apptDepartments[0].internalId !== '1034002261'*/) {
                                const newDepartment = apptDepartments[0];
                                appointment.departmentId = newDepartment.internalId;
                                departments.push({ id: newDepartment.internalId, name: newDepartment.name, selected: true }); // add this department in the list of departments
                                departmentsDictionary[newDepartment.internalId] = 1; // count is initialized to 1 as one appointment is found in this department so far
                                totalCount++;
                            }
                        });
                    }

                    // update departments
                    if (isSameDayCare) {
                        const sdcDepartment = { id: '1034002261', name: 'SAME DAY CARE', displayName: `SAME DAY CARE (${totalCount})`, isSameDayCare: true };
                        const lastIndex = allDepartments.length - 1;
                        if (allDepartments[lastIndex].id === '1034002261') {
                            sdcDepartment.selected = videoVisit.providerInfo[lastIndex].selected;
                            videoVisit.providerInfo[lastIndex] = sdcDepartment;
                        }
                        else {
                            videoVisit.providerInfo.push(sdcDepartment);
                        }
                    }
                    else {
                        allDepartments[0].displayName = `All Departments (${totalCount})`;
                        departments.filter(dep => !dep.isSameDayCare).forEach(dep => dep.displayName = `${dep.name} (${departmentsDictionary[dep.id]})`); // displayName = name followed by (volume of appointments)
                        videoVisit.providerInfo = [allDepartments[0]].concat(departments); // department list re-constructed along with departments not returned by the providerInfo call like on-the-fly department
                    }
                }

                if (!result.err) {
                    //const oAppointments = JSON.parse(result.result.Result);
                    yield put({ type: types.EPIC_PROVIDER_APPOINTMENTS_SET_DATA, appointments: result.result.rooms, isSameDayCare });
                }
                else {
                    yield put({ type: types.EPIC_PROVIDER_APPOINTMENTS_GET_FAILURE, isSameDayCare });
                }
                yield put({ type: types.EPIC_PROVIDER_APPOINTMENTS_GET_END, isSameDayCare });
            }
            catch (EE2) {
                console.error(EE2);
                yield put({ type: types.EPIC_PROVIDER_APPOINTMENTS_GET_END, isSameDayCare });
            }
        }
    }
    catch (E) {
        //debugger;
    }
}

export function* LoadPhyndData(sLan) {
    var oPhyndData = {};
    try {
        const domain = yield select((state) => state.domain);
        const session = yield select((state) => state.session);
        oPhyndData = session.phyndData;
        if (!oPhyndData || oPhyndData.err) {
            if (domain.lan && domain.t) {
                oPhyndData = yield Tools.safeCall(providerAPI.getProviderByLanID, sLan ?? domain.lan, domain.t);
                if (!oPhyndData.err && oPhyndData.result && oPhyndData.result.length > 0) {
                    yield put({ type: types.SET_PHYND_DATA, data: oPhyndData });
                }
            }
        }
    }
    catch (E) {
        console.error(E);
    }
    return oPhyndData;
}

export function* FetchInstadocToken() {
    const domain = yield select((state) => state.domain);
    var oInstaDocToken = {};
    if (domain.adt) {
        yield put({ type: types.INSTADOC_TOKEN_GET_START });
        oInstaDocToken = yield Tools.safeCall(instaDocBFFAPI.exchangeToken, domain.adt);
        if (!oInstaDocToken.err && oInstaDocToken.result && oInstaDocToken.result.tokenString && oInstaDocToken.result.tokenString !== "") {
            yield put({ type: types.INSTADOC_SET_TOKEN, data: oInstaDocToken.result });
            domain.idt = oInstaDocToken.result.tokenString;
        }
        yield put({ type: types.INSTADOC_TOKEN_GET_END });
        return oInstaDocToken;
    }
}

export function* PostLoginAsyncDataLoad(data, sLanID) {
    const start = new Date();
    try {
        yield put({ type: types.POSTLOGIN_PROCESS_START });
        //var oPhyndData = yield LoadPhyndData(sLanID);
        if (enableSyncCall) {// && oPhyndData && !oPhyndData.err && oPhyndData.result && oPhyndData.result.length > 0) {
            yield put({ type: types.SYNC_ROOMS });
        }
        yield put({ type: types.POSTLOGIN_PROCESS_END });
    }
    catch (ex) {
        //debugger;
        console.error(ex);
        yield put({ type: types.POSTLOGIN_PROCESS_END });
        logAPI("Saga.SSO.ADAuthenticated.Failure", start, null, data);
    }
}

function formatZeroes(sVal) {
    if (sVal.length < 2) {
        sVal = '0' + sVal;
    }
    return sVal;
}

export function* ADAuthenticated(data) {
    const start = new Date();
    try {
        var domain = yield select((state) => state.domain);

        //debugger;
        if (domain.adt) {
            yield put({ type: types.START_TOKEN_EXCHANGE });
            var oNewToken = yield Tools.safeCall(ConvertToken, domain.adt, domain.un);
            //debugger;
            yield put({ type: types.SET_HEALTH_SOURCE_TOKEN, result: oNewToken.result });
            logAPI("Saga.SSO.ADAuthenticated", start, null, data);
            //debugger;
            domain = yield select((state) => state.domain);
            //yield loadTermsAndConditions();
            yield onUserAuthenticateSuccess(oNewToken.result, oNewToken.result.LanID);
            yield put({ type: types.USER_AUTHENTICATE_SUCCESS, userData: oNewToken.result });
            yield put({ type: types.END_TOKEN_EXCHANGE });
            yield put({ type: types.POST_LOGIN_START });

            if (enableSyncCall && domain.er !== 'staff') { // && data.loadRooms && domain.idt) {
                yield put({ type: types.SYNC_ROOMS });
                //yield LoadProviderAppointments(domain.idt, [domain.eid]);
            }
        }
    }
    catch (ex) {
        console.error(ex);
        logAPI("Saga.SSO.ADAuthenticated.Failure", start, null, data);
    }

}


export function* saveShowTutorial(data) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        //debugger;
        yield Tools.safeCall(account.setHideTutorial, domain.t);
        logAPI("Saga.SSO.ShowTutorial.Save", start, null, data);
    }
    catch (ex) {
        console.error(ex);
        logAPI("Saga.SSO.ShowTutorial.Save.Failure", start, null, data);
    }
}

export function* loadTermsAndConditions() {
    const start = new Date();
    try {
        const terms = yield Tools.safeCall(portalAPI.getTermsAndConditions);
        //debugger;       
        if (!terms.err && terms.result && terms.result.isSuccessful) {
            yield put({ type: types.SET_TERMS_AND_CONDITIONS, terms: terms.result.textToDisplay, version: terms.result.versionId });
            let andyliticResponse = JSON.parse(JSON.stringify(terms));
            if (andyliticResponse && andyliticResponse.result && andyliticResponse.result.textToDisplay) {
                andyliticResponse.result.textToDisplay = '';
            }
            logAPI("Saga.SSO.TermsAndConditions.Get", start, null, andyliticResponse);
        }
        //debugger;

    }
    catch (e) {
        console.error(e);
        logAPI("Saga.SSO.TermsAndConditions.Get.Failure", start, null);
    }

}

export function* handleRedirect(reDirectURL) {
    const start = new Date();
    const history = yield select((state) => state.session.history);
    const domain = yield select((state) => state.domain);
    if (typeof window !== 'undefined') {
        if (reDirectURL && window.location.pathname !== reDirectURL) {
            //debugger;
            //alert("Redirecting to redir url: " + reDirectURL);
            const reDirectURLWithQP = domain.qp ? reDirectURL + domain.qp : reDirectURL;
            //debugger;
            history.push(reDirectURLWithQP);
            logAPI("Saga.SSO.Redirect", start, null, reDirectURLWithQP);
        }
        yield put({ type: types.CLEAR_REDIRECT_URL });

    }

}

export function* acceptTermsAndConditions(data) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        //debugger;
        if (domain.li) {
            const accept = yield call(portalAPI.acceptTermsAndConditions, domain.t, domain.un, data.VersionID);
            const reDirectURL = domain.ru;
            const history = yield select((state) => state.session.history);

            yield put({ type: types.SET_TERMS_AND_CONDITIONS, HasAccepted: true });

            yield handleRedirect(reDirectURL);
            logAPI("Saga.SSO.TermsAndConditions.Accept", start, null, JSON.stringify(accept));
        }
    }
    catch (ex) {
        //debugger;
        console.error(ex);
        logAPI("Saga.SSO.TermsAndConditions.Accept.Failure", start, null, null);
    }
}


export function* refreshToken() {
    const start = new Date();
    //debugger;
    const domainData = yield select((state) => state.domain);
    //debugger;
    if (domainData.rt) {
        yield put({ type: types.USER_AUTHENTICATE_REFRESH, refresh_token: domainData.rt });
        logAPI("Saga.SSO.RefreshToken.Get", start, null);
    } else {
        //Adding more log to validate mobile issue for linking
        logAPI("Saga.SSO.RefreshToken.Error.NoRefreshToken", start, null);
    }
}


export function* loginSuccess(paylog) {
    //debugger;
    try {
        const sDomain = yield getDomain();
        Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
    }
    catch (err) {
        console.error(err);
    }

}


export function* authorize(payload) {
    const start = new Date();
    try {
        const response = yield call(userAuthenticate, payload);
        //debugger;

        yield onUserAuthenticateSuccess(response);
        if (response && response.access_token) {
            yield put({ type: types.LOGIN_FORM_SUCCESS, error: null, isWaiting: false });
            logAPI("Saga.SSO.Authenticate.Login", start, null);
        }
        else {
            logAPI("Saga.SSO.Authenticate.Login.Failure", start, null);
        }
    }
    catch (error) {
        console.error(error);
        logAPI("Saga.SSO.Authenticate.Login.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}

export function* CallIsLoggedIn(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);

        const response = yield call(isLoggedInPost2, domain.t);
        //debugger;
        yield onUserAuthenticateSuccess(response);
        logAPI("Saga.SSO.IsLoggedIn", start, null, response);
    }
    catch (error) {
        console.error(error);
        logAPI("Saga.SSO.IsLoggedIn.Failure", start, null, null);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}



var bInRefresh = false;

export function* refresh(payload) {
    const start = new Date();
    try {
        const response = yield call(userRefresh, payload);
        //debugger;
        if (response && response.access_token) {
            yield onUserAuthenticateSuccess(response);
            logAPI("Saga.SSO.Refresh", start, null);
        }
        else {
            yield put({ type: types.REFRESH_TOKEN_FAILURE, userData: response, responseError: response.error, isWaiting: false });
            logAPI("Saga.SSO.Refresh.Failure", start, null);
        }
        if (response && !response.IsLoggedIn) {
            yield put({ type: types.VERIFY_LOGIN, error: null, isWaiting: false });
            logAPI("Saga.SSO.Refresh.Failure", start, null);
        }
    }
    catch (error) {
        console.error(error);
        bInRefresh = false;
        logAPI("Saga.SSO.Refresh.Failure", start, null, null);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }

}

export function* onUserAuthenticateSuccess(response, sLanID) {
    const start = new Date();
    try {
        if (response && response.access_token) {
            //debugger;
            const hasMyChart = response.Logins.indexOf('MyChart') > -1;
            const hasAutoMyChart = response && response.AUTO_MyChartID ? true : false;
            const hasHealthPlan = response.Logins.indexOf('HealthPlan') > -1;
            const enableAutoMyChartLink = typeof window !== 'undefined' && window.serverData.data.enableMyChartAutoLink;
            const enableCaptureInsurance = typeof window !== 'undefined' && window.serverData.data.enableCaptureInsurance;
            const token = response.access_token;
            const userName = response.userName;

            yield PostLoginAsyncDataLoad(null, sLanID);

            //For mychart users validating preference to show Insurance form before landing into dashboard.
            let insurancePref = null;
            let captureInsuranceForm = false;
            if (hasMyChart && enableCaptureInsurance) {
                insurancePref = yield Tools.safeCall(account.getUserPreferences, token, "ShowCaptureInsuranceForm");
                if (insurancePref && !insurancePref.err && insurancePref.result && insurancePref.result.length > 0 && insurancePref.result[0]) {
                    logAPI("Saga.SSO.InsurancePreference.Get", start, null, JSON.parse(JSON.stringify(insurancePref.result[0])));
                    if (insurancePref.result[0].isSuccessful && insurancePref.result[0].preferenceValue === "true") {
                        captureInsuranceForm = true;
                        yield put({ type: types.SHOW_INSURANCE_FORM, showInsuranceForm: captureInsuranceForm });
                        logAPI("Saga.SSO.InsurancePreference.CaptureInsuranceForm", start, null, null);
                    }
                } else {
                    logAPI("Saga.SSO.InsurancePreference.Get.Failure", start, null, null);
                }
            }

            yield put({ type: types.USER_AUTHENTICATE_SUCCESS, userData: response, responseError: response.error, isWaiting: false });

            const domain = yield select((state) => state.domain);

            const history = yield select((state) => state.session.history);
            const reDirectURL = domain.ru;

            var isMobile = false;
            try {
                isMobile = domain.mq;
            }
            catch (EE) {
            }

            var terms = {
                result: {
                    isSuccessful: true,
                    isAccepted: true
                }
            };

            // We can also route from here to terms and conditions
            if (typeof window !== 'undefined') {
                if (!terms.err && terms.result && terms.result.isSuccessful && !terms.result.isAccepted && !isMobile) {
                    //debugger;
                    if (window.location.pathname !== "/login") {
                        // Write this as the new redirect URL (in case we refreshed after deleting login cookie)
                        yield put({ type: types.SET_REDIRECT_URL, URL: window.location.pathname });
                    }
                    history.push({
                        pathname: '/acceptterms'
                    });
                    if (captureInsuranceForm) {
                        yield put({ type: types.SET_REDIRECT_URL, URL: "/captureinsurance" });
                    }
                } else if (captureInsuranceForm) {
                    history.push("/captureinsurance");
                }
                else if (reDirectURL) {
                    yield handleRedirect(reDirectURL);
                }
                else if (window.location.pathname === "/login") {
                    //alert("Snapping to root");
                    //debugger;
                    history.push("/");
                }
            }


            //var oSignalR = yield Tools.safeCall(instaDocBFFAPI.negotiateSignalR);
            //if (oSignalR) {
            //yield put({ type: types.SIGNALR_INIT, data: oSignalR.result });
            //}

            //yield put({ type: types.GET_PROVIDER_JWT, token: response.access_token });
            if (enableSyncCall) {
                yield put({ type: types.SYNC_ROOMS });
            }

            if (manageProviderMobileNoInSettings && domain.er === 'provider') {
                try {
                    yield put({ type: types.USER_SETTINGS, event: 'Login', lanId: sLanID, waiting: true });
                    const userSettings = yield call(instaDocBFFAPI.settings, domain.idt, sLanID, 'GET', { epicExternalId: domain.eid });
                    userSettings.showModal = !userSettings.smsNumber && userSettings.smsNumberPopupCount < 2;
                    yield put({ type: types.USER_SETTINGS, ...userSettings, waiting: false, error: null });
                    logAPI('Saga.SSO.UserSettings.Login', new Date(), userSettings);
                }
                catch (error) {
                    yield put({ type: types.USER_SETTINGS, error, event: 'Login.Failure', waiting: false });
                    logAPI('Saga.SSO.UserSettings.Login.Failure', new Date(), error);
                }
            }

            logAPI("Saga.SSO.OnUserAuthenticateSuccess", start, null);
        }
        else {
            //debugger;
            console.error("Saga.SSO.OnUserAuthenticateSuccess.Failure", response);
            logAPI("Saga.SSO.OnUserAuthenticateSuccess.Failure", start, null);
            yield put({ type: types.USER_AUTHENTICATE_FAILURE, userData: response, responseError: response.error_description ? response.error_description : response.error && response.error === "invalid_grant" ? msgs.LoginInvalidGrantMessage : response.error, isWaiting: false });
        }
    }
    catch (err) {
        console.error("Saga.SSO.OnUserAuthenticateSuccess.FailureCatch", err);
        logAPI("Saga.SSO.OnUserAuthenticateSuccess.Failure", start, null, err);
    }
}

export function* handleUserSettings(data) {
    try {
        if (data.event === 'GetSettings') {
            const domain = yield select(state => state.domain);
            const response = yield call(instaDocBFFAPI.settings, domain.idt, data.lanId || domain.lan, 'GET', { epicExternalId: domain.eid });
            yield put({ type: types.USER_SETTINGS, ...response, waiting: false, error: null });
            logAPI('Saga.SSO.UserSettings.' + data.event, new Date(), response);
        }
        else if (data.event === 'IncrementPopupCount' || data.event === 'UpdateMobileNumber' || data.event === 'SavePreference') {
            const domain = yield select(state => state.domain);
            const response = yield call(instaDocBFFAPI.settings, domain.idt, data.lanId || domain.lan, 'PATCH', { ...data.payload, epicExternalId: domain.eid });
            yield put({ type: types.USER_SETTINGS, ...data.payload, ...response, waiting: false, error: null });
            logAPI('Saga.SSO.UserSettings.' + data.event, new Date(), { success: response.ok });
        }
    }
    catch (error) {
        yield put({ type: types.USER_SETTINGS, error, event: data.event + '.Failure', waiting: false });
        logAPI('Saga.SSO.UserSettings.' + data.event + '.Failure', new Date(), error);
    }
    finally {
        if (data.callback) {
            data.callback();
        }
    }
}

export function* verifyLogin(payload) {
    const start = new Date();
    try {
        //debugger;
        const domain = yield select((state) => state.domain);
        //debugger;
        const ssoResponse = yield call(isLoggedInPost2, domain.t);
        //debugger;
        yield onUserAuthenticateSuccess(ssoResponse);
        const loggedin = ssoResponse.IsLoggedIn;
        if (loggedin === false) {
            console.log("LOGOUT");
            //debugger;
            yield put({ type: types.LOGOUT, userDetails: {}, DontClearRedirectURL: payload.DontClearRedirectURL });
            logAPI("Saga.SSO.VerifyLogin", start, null);
        }
        else {
            if (payload.forceRefresh) {
                //debugger;
                yield put({ type: types.REFRESH_TOKEN });  // this allows us to refresh any changes that may have been to the account by an external site
            }
        }
        yield put({ type: types.VERIFY_LOGIN_COMPLETED });
    }
    catch (error) {
        console.error("Saga.SSO.VerifyLogin.Failure", error);
        logAPI("Saga.SSO.VerifyLogin.Failure", start, null, JSON.stringify(error));
        yield put({ type: types.VERIFY_LOGIN_COMPLETED });
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}

export function* logoutRedirect(data) {
    const start = new Date();
    try {

        // clear proxy on logout
        const sDomain = getDomain();
        Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });

        //debugger;
        const history = yield select((state) => state.session.history);
        try {
            const oIgnore = yield call(userLogout);
            const domain = yield select((state) => state.domain);
            Cookies.expire('location_' + domain.un, { domain: Tools.getDomain(location.href) });
            Tools.clearItemFromSessionStorage('insurance_' + domain.un);
            //const covidScreeningModalKey = window && window.serverData.data.showCOVID19ModalPerUser ? domain.cu && domain.cu.dn && domain.cu.eid ? domain.un + '_' + domain.cu.dn + '_' + domain.cu.eid : domain.un : domain.un;           
            Tools.clearItemFromSessionStorageWithStrContains(msgs.CovidScreeningModalSessionKeyInitial + domain.un);  // using domain.un and not  covidScreeningModalKey as we want to clean key for primary as well as its proxies.
        }
        catch (e) { console.log(e); }

        //debugger;
        yield put({ type: types.LOGOUT_COMPLETED, logoutMessage: data.logoutMessage }); // this forces the UI to update

        //debugger;
        if (window.location.pathname !== "/login" && !data.DontClearRedirectURL && window.location.pathname !== "/reset") {
            try {
                //alert("Manually switching to Login page");
                //debugger;
                history.push("/login");
            }
            catch (ex) {
                console.error(ex);
                logAPI("Saga.SSO.LogoutRedirect.Failure", start, null, JSON.stringify(ex));
            }

        }

        logAPI("Saga.SSO.LogoutRedirect", start, null);
        yield put({ type: types.USER_LOGGED_OUT, DontClearRedirectURL: data.DontClearRedirectURL, logoutMessage: data.logoutMessage });

        authContext.logOut();



    }
    catch (err) {
        console.error(err);
        logAPI("Saga.SSO.LogoutRedirect.Failure", start, null, JSON.stringify(err));
    }
}